<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div actions>ngx-ui-scroll version is {{ version }}</div>
  <div description>
    <p>
      <em>Adapter.init$</em> is a <em>Subject&lt;boolean&gt;</em> property that
      fires once after
      the <em>Adapter</em> is initialized and the Scroller is ready to run.
      There is also <em>Adapter.init</em> read-only boolean property. An
      important point is that there is a time gap between the Datasource/Adapter
      instantiation and the Scroller/Adapter initialization. In other words, we
      may instantiate the Datasource long before the Scroller's viewport is
      rendered and it starts working.
    </p>
    <p>
      This demo displays <em>ngx-ui-scroll</em> version taken from the
      <em>Adapter</em>. The <em>Adapter.init$</em> subscription is used to set
      <em>version</em> property exactly when the <em>Adapter</em> initializes
      and receives all data.
    </p>
    <p>
      The second tab (OnPush) implements <em>OnPush</em> strategy with an
      additional <em>changeDetector</em> call, which is required to update the
      view, because initialization is an asynchronous process. If we remove
      <em>changeDetector</em> call, we see 3 dots, the initial value.
    </p>
  </div>
</app-demo>
